import { render, staticRenderFns } from "./DashboardPeople.vue?vue&type=template&id=5a92e8d1&scoped=true&"
import script from "./DashboardPeople.vue?vue&type=script&lang=js&"
export * from "./DashboardPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92e8d1",
  null
  
)

export default component.exports